$(document).ready(function () {

    let search = '.search-page-not-found';

    function redirect(value) {
        window.location = config.url_search+'?term=' + value;
    }

    $(search+' input').on('keyup click', function (e) {
        e.stopPropagation();

        let value = $(this).val();
        
        if (e.which == 13) {
            redirect(value)
        } else {
            
            let noWhitespaceValue = value.replace(/\s+/g, '');
            let noWhitespaceCount = noWhitespaceValue.length;
            if (noWhitespaceCount >= 3) {
                
                if ($('.overlay-gradient').length == 0) {
                    setOverlay('body', 'search');
                }
                $(search+' .search-content').removeClass('d-none');
                checkUniqueName();
            }
        }
    });

    $(search+' .search-button').on('click', function () {
        if ($(search+' input').val().length != 0) {
            redirect($(search+' input').val())
        }
    });

    let searchbarTimer;

    $(search+' input, '+search+' .search-content').on('mouseenter', function() {
        if (typeof searchbarTimer != 'undefined') {
            clearTimeout(searchbarTimer);
        }
    });
    
    $(search+' input, '+search+' .search-content').on('mouseleave', function (e) {
    
        let self = $(this);
    
        searchbarTimer = setTimeout(function() {
            $(search+' .search-content').addClass('d-none');

            if ($('.overlay-gradient').length != 0) {
                setOverlay('body');
            }
        }, 1500);
    });

    $(document).on('click', '.search-gradient', function () {
        $(search+' .search-content').addClass('d-none');
        setOverlay('body');
        clearTimeout(searchbarTimer);
    });


    let xhrUniqueName;
    let iCheckUniqueNameTimeout;
    function checkUniqueName(delay = 300) {
        
        $(search+' .search-loader').show();

        if (iCheckUniqueNameTimeout) {
            clearTimeout(iCheckUniqueNameTimeout);
        }

        iCheckUniqueNameTimeout = setTimeout(function () {

            if (xhrUniqueName && xhrUniqueName.readyState != 4) {
                xhrUniqueName.abort();
            }

            xhrUniqueName = $.ajax({
                'url': config.domain + '/frontend/functions/search.php?query=' + $(search+' input').val(),
                'method': 'GET',
                'async': false,
                'success': function (data) {
                    console.log(data)
                    
                    $(search+' .search-loader').hide();

                    let parent = $(search+' .search-content .content');

                    parent.empty();
                    let count = 0;
                    let countItems = 0;
                    let checkForSubs = 0;

                    for(let key in data) {

                        let subs = data[key].data

                        if(subs.length > 0) {

                            parent.append('<div class="header-dropdown-title">' + data[key].title + '</div>')
                            let container = '<div class="search-items item-block-' + count + '"></div>'
                            parent.append(container)
        
                            for (let q in subs) {
                                $('.item-block-' + count).append('<a href="' + config.domain + '/' + subs[q]['slug_data'] + '" class="d-block text font-weight-light">' + subs[q]['title']+ '</a>')
                                
                                countItems++;
                            }
        
                            if (count < data['count'] - 1) {
                                parent.append('<div class="border border-bottom mb-3 mt-2"></div>')
                            }
        
                            count++;
                        } else {
                            checkForSubs++;
                        }
                    }

                    if (count == 0) {
                        parent.append('<div class="search-items">' + $(search+' div').data('no-results') + '</div>')
                        $(search+' .btn-show-results').addClass('d-none');
                    } else {
                        $(search+' .btn-show-results').removeClass('d-none');
                    }

                    if (countItems == 1) {
                        $(search+' .btn-show-results').text($(search+' .btn-show-results').data('singular').replace('%', countItems));
                    } else {
                        $(search+' .btn-show-results').text($(search+' .btn-show-results').data('plural').replace('%', countItems));
                    }

                    $(search+' .btn-show-results').attr('href', config.url_search + '?term=' + $(search+' input').val());

                }
            });
        }, delay);

    }

    $('.header-row').on('click', search, function (e) {
        $(this).addClass('active');
        if ($(".overlay-gradient").length == 0) {
            setOverlay('body');
        }
    });
});